import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataJj from './phonics/phonics_data_jj';

function PhonicsJj() {
  return <PhonicsAtoZ letterData={letterDataJj} />;
}

export default PhonicsJj;